<div (mouseenter)="this.dotComService.DisplaySubMenu('')">
    <div class="headerImageHeight" style="background-size: cover; background-position:center;"
        [ngStyle]="{backgroundImage: 'url(' + this.pageImagePaths + 'header-image.png)'}">
        <div class="row">
            <div style="width:22%"></div>
            <div *ngIf="myHarrellsService.bootstrapViewPortSize != ''" class="text-center whiteText" style="width:56%">
                <h1 *ngIf="(myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm')"
                    class="DINNextLTPro-Black whiteText headerImageTextLarge" style="text-transform: uppercase;">TEAM
                </h1>
                <h1 *ngIf="myHarrellsService.bootstrapViewPortSize && myHarrellsService.bootstrapViewPortSize != '' && !(myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm')"
                    class="DINNextLTPro-Black whiteText headerImageTextLarge" style="text-transform: uppercase;">PEOPLE
                    WHO
                    CARE, <br>EXPERTISE YOU CAN TRUST</h1>
            </div>
            <div style="width:22%"></div>
        </div>
    </div>
    <div class="row mb-2 whiteBackground" style="margin-top:80px">
        <h2 class="Caecilia76BoldItalic greenText" style="text-align: center; font-size:28px; font-weight: 700;">
            Our Leadership</h2>
    </div>
    <div class="row mb-1 whiteBackground" style="margin:auto; width:80%; max-width:800px">
        <h4 class="DIN2014Regular"
            style="text-align: center; font-size:19px; line-height: 27px; letter-spacing:.38px; font-weight: 400;">
            Our visionary leadership team, with its wealth of industry experience and passion for progress, drives
            innovation and excellence. They inspire our organization toward strategic goals, fostering a culture of
            collaboration, integrity, and continuous improvement. This ensures we remain at the forefront of our
            industry and can serve our customers well.
        </h4>
    </div>
    <!-- exec team -->
    <div class="col-lg-12 mt-5" style="max-width:1030px; margin:auto; margin-bottom:3%; border-bottom:1px solid grey">
        <div class="row" style="text-align:left">
            <div class="col-lg-4" *ngFor="let emp of this.execTeam" style="margin-bottom:3%;">
                <div class="text-center">
                    <img style="height:280px;width:320px;object-fit: cover;" src={{emp.empPhoto}} alt="emp image">
                    <h5 class="DIN2014Regular"
                        style="font-size:21px; line-height: 19px; font-weight:700;letter-spacing: .42px; padding-top:20px">
                        {{emp.FirstName| uppercase}} {{emp.LastName| uppercase}}</h5>
                    <h5 class="DIN2014Regular"
                        style="text-transform:capitalize; font-size:19px; line-height: 19px; font-weight:400; letter-spacing: .38px; padding-left:10px; padding-right:10px">
                        {{emp.Title}}</h5>
                    <h5><a class="DIN2014Regular"
                            style="color:black; text-decoration: underline; font-size:19px; line-height: 19px; font-weight:400; letter-spacing: .38px; padding-left:10px; padding-right:10px"
                            href="mailto:{{emp.email}}">{{emp.email}}</a></h5>
                </div>
            </div>
        </div>
    </div>

    <!-- our team -->
    <div class="row mt-5 mb-2 whiteBackground">
        <h2 class="Caecilia76BoldItalic greenText" style="text-align: center; font-size:28px; font-weight: 700;">
            Our Team</h2>
    </div>
    <div class="row mb-1 whiteBackground" style="margin:auto; width:80%; max-width:800px">
        <h4 class="DIN2014Regular"
            style="text-align: center; font-size:19px; line-height: 27px; letter-spacing:.38px; font-weight: 400;">
            At the heart of Harrell’s is a team of dedicated professionals, each contributing their unique expertise and
            passion. Our diverse backgrounds and collective experience drive innovative solutions and exceptional
            service.
        </h4>
    </div>
    <div class="row mb-1 whiteBackground" style="margin:auto; width:80%; max-width:1500px;">
        <select style="width:350px; height:50px; margin:auto; gap:10px;" (change)="GetSelectedTeamsEmployees()"
            [(ngModel)]="this.selectedDeptId">
            <option *ngFor="let dept of this.departments" class="DIN2014Regular"
                style="color:black !important; background-color:white !important; font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400;"
                value={{dept.Id}}>
                {{dept.name}}</option>
        </select>
    </div>
    <div class="col-lg-12 mt-3" style="max-width:1125px; margin:auto;margin-top:50px !important">
        <div class="row" style="text-align:left" *ngIf="this.showEmpsgrid">
            <div class="col-lg-3 p-0" *ngFor="let emp of this.deptTeam">
                <div class="text-center" (mouseenter)="ChangeOpacity(emp.Id)" (mouseleave)="ChangeOpacityBack(emp.Id)">
                    <img id={{emp.Id}} style="height:280px;width:290px;object-fit: cover;" src={{emp.empPhoto}}
                        alt="emp image">
                    <div [id]="emp.Id+'detail'"
                        style="display:none; position:relative; margin-top:-200px;width:270px; height:200px; margin-left:auto; margin-right:auto">
                        <h5 class="DIN2014Regular"
                            style="width:80%;font-size:21px; line-height: 19px; font-weight:700;letter-spacing: .42px; padding-top:20px;margin:auto">
                            {{emp.FirstName|uppercase}} {{emp.LastName|uppercase}}</h5>
                        <h5 class="DIN2014Regular"
                            style="width:80%;text-transform:capitalize; font-size:19px; line-height: 19px; font-weight:400; letter-spacing: .38px; margin:auto">
                            {{emp.Title}}</h5>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="row mt-5 mb-2 whiteBackground" style="width:80%; max-width:1500px;margin:auto">
        <h2 class="Caecilia76BoldItalic greenText" style="text-align: left; font-size:28px; font-weight: 700;">
            Join The Best Team In The Industry!</h2>
    </div>
    <div class="row mb-5 whiteBackground" style="margin:auto; width:80%; max-width:800px">
        <h4 class="DIN2014Regular"
            style="text-align: left; font-size:19px; line-height: 27px; letter-spacing:.38px; font-weight: 400;">
            At the heart of our company is a team of dedicated professionals, each bringing unique expertise and passion
            to the table. Our diverse backgrounds and collective experience drive our innovative solutions and
            exceptional service. We believe in the power of collaboration and are committed to achieving excellence
            together.
        </h4>
        <h3 class="mt-3">
            <a class="DINNextLTPro-Black lightBlueBackground blueText"
                style=" font-size:20px; font-weight:900; padding:8px; text-decoration: none !important"
                href='/contact'>JOIN US NOW</a>
        </h3>
    </div> -->

    <div class="col-lg-12" style="max-width:1125px; margin:auto;margin-top:80px !important">
        <div class="row" style="margin:auto">
            <h4 class="Caecilia76BoldItalic greenText" style="text-align: LEFT; font-size:28px; font-weight: 700;">Join
                The Best Team In The Industry!</h4>
        </div>
        <div class="row" style="margin:auto">
            <h5 class="DIN2014Regular"
                style="width:80%;text-align: LEFT; font-size:19px; line-height: 30px; letter-spacing: .38px; font-weight: 400;">
                At the
                heart of our company is a team of dedicated professionals, each bringing unique expertise and passion to
                the
                table. Our diverse backgrounds and collective experience drive our innovative solutions and exceptional
                service. We believe in the power of collaboration and are committed to achieving excellence together.
            </h5>
        </div>
        <div class="row pt-4" style="margin:auto; margin-bottom:80px">
            <h3><a class="DINNextLTPro-Black lightBlueBackground blueText"
                    style=" font-size:20px; font-weight:900; padding:8px; text-decoration: none !important"
                    href='/careers'>VIEW OPEN POSITIONS</a>
            </h3>
        </div>
    </div>


    <div class="blueBackground pt-5 pb-5">
        <div class="row" style="padding-left:50px; padding-right:50px;max-width:1350px; margin:auto">
            <div class="row ml-5 mr-5 mb-5" style="padding-left:3%">
                <h2 class="Caecilia76BoldItalic blueBackground whiteText pt-3"
                    style="font-size:28px; font-weight: 700; margin-bottom:0px !important">Contact Information
                </h2>

            </div>
            <div class="col-lg-4  whiteText" style="padding-left:3%">
                <h3 class="DIN2014Bold"
                    style="font-size:21px; line-height: 27px; font-weight: 600; text-decoration: underline;">CORPORATE
                    OFFICE +
                    DELIVERIES
                </h3>
                <h5 class="DIN2014Regular" style="font-size:19px; line-height:27px; font-weight:400">
                    {{this.dotComService.corpOffice[0].address}}</h5>
                <h5 class="DIN2014Regular" style="font-size:19px; line-height:27px; font-weight:400">
                    {{this.dotComService.corpOffice[0].city}},
                    {{this.dotComService.corpOffice[0].state}} {{this.dotComService.corpOffice[0].zip}}</h5>
                <h5 class="DIN2014Regular"
                    style="color:white !important;font-size:19px; line-height:27px; font-weight:400">TF:
                    <a class="telephoneNmbr" href='tel:800-282-8007'>800-282-8007</a>
                </h5>
                <h5 class="DIN2014Regular"
                    style="color:white !important;font-size:19px; line-height:27px; font-weight:400">P: <a
                        class="telephoneNmbr" href='tel:863-687-2774'>863-687-2774</a></h5>
                <h5 class="DIN2014Regular"
                    style="color:white !important;font-size:19px; line-height:27px; font-weight:400">F: <a
                        href="javascript: void(0)" style="color:white !important">863-688-8836</a></h5>
                <h3 style="margin-top:20px"><a class="DIN2014Bold whiteBackground greenText"
                        style="cursor:pointer;font-size:20px ;padding:8pt; text-decoration: none !important"
                        (click)="GetDirections(this.dotComService.corpOffice[0])">GET
                        DIRECTIONS</a>
                </h3>
                <h3 class="DIN2014Bold pt-5"
                    style="font-size:21px; line-height: 27px; font-weight: 600; text-decoration: underline;">PAYMENTS
                    ADDRESS
                </h3>
                <h5 class="DIN2014Regular" style="font-size:19px; line-height:27px; font-weight:400">PO Box 935358</h5>
                <h5 class="DIN2014Regular" style="font-size:19px; line-height:27px; font-weight:400">Atlanta, GA
                    31193-5385
                </h5>
                <h5 class="DIN2014Regular"
                    style="color:white !important;font-size:19px; line-height:27px; font-weight:400">P: <a
                        class="telephoneNmbr" href='tel:800-780-2774'>800-780-2774 x3</a></h5>
            </div>
            <div class="col-lg-4 whiteText mailingAddressOuter">
                <h3 class="DIN2014Bold pt-5 pt-md-0"
                    style="font-size:21px; line-height: 27px; font-weight: 600; text-decoration: underline;">MAILING
                    ADDRESS
                </h3>
                <h5 class="DIN2014Regular"
                    style="color:white !important;font-size:19px; line-height:27px; font-weight:400">PO Box 807</h5>
                <h5 class="DIN2014Regular"
                    style="color:white !important;font-size:19px; line-height:27px; font-weight:400">Lakeland, FL 33802
                </h5>

                <h3 class="DIN2014Bold pt-5"
                    style="font-size:21px; line-height: 27px; font-weight: 600; text-decoration: underline;">EMERGENCY
                    NUMBERS
                </h3>
                <h5 class="DIN2014Regular"
                    style="color:white !important;font-size:19px; line-height:27px; font-weight:400">PRODUCT: <a
                        class="telephoneNmbr" href='tel:800-304-0824'>800-304-0824</a>
                </h5>
                <h5 class="DIN2014Regular"
                    style="color:white !important; font-size:19px; line-height:27px; font-weight:400">TRANSPORTATION:
                    <a class="telephoneNmbr" href='tel:800-424-9300'>800-424-9300</a>
                </h5>
                <h3 class="DIN2014Bold pt-5"
                    style="font-size:21px; line-height: 27px; font-weight: 600; text-decoration: underline;">HUMAN
                    RESOURCES
                </h3>
                <h5 class="DIN2014Regular" style="font-size:19px; line-height:27px; font-weight:400">HR&#64;Harrells.com
                </h5>
                <h5 class="DIN2014Regular"
                    style="color:white !important;font-size:19px; line-height:27px; font-weight:400">F: <a
                        href="javascript: void(0)" style="color:white !important">863-688-8836</a></h5>
            </div>
            <div class="col-lg-4 whiteText creditContactOuter">
                <h3 class="DIN2014Bold pt-5 pt-md-0"
                    style="font-size:21px; line-height: 27px; font-weight: 600; text-decoration: underline;">CREDIT
                    CONTACT
                </h3>
                <h5 class="DIN2014Regular" style="font-size:19px; line-height:27px; font-weight:400">
                    Credit&#64;Harrells.com
                </h5>
                <h5 class="DIN2014Regular"
                    style="color:white !important;font-size:19px; line-height:27px; font-weight:400">P: <a
                        class="telephoneNmbr" href='tel:800-780-2774'>800-780-2774 x5</a></h5>
                <h5 class="DIN2014Regular"
                    style="color:white !important;font-size:19px; line-height:27px; font-weight:400">F: <a
                        href="javascript: void(0)" style="color:white !important">863-583-0695</a></h5>
            </div>
        </div>
    </div>




</div>